module.exports = __webpack_public_path__ + "static/xevadb-logo-8ef905512cbbfc647544255c3aad363a.png";